/**
 * Loading skeleton shaped like an article detail page (breadcrumb,
 * chip, title, summary, metadata, divider, body content). Used by both
 * `ArticleDetail` while waiting on `useArticle()` and by `ArticleEditor`
 * while waiting on the initial article fetch — so the two routes share a
 * single loading visual instead of jumping between different skeletons.
 *
 * Padding mirrors `ArticleDetail`'s outer Box (`px: 2`) so the skeleton
 * sits in the same horizontal channel as the eventual content.
 */

import React from "react";
import { Box, Divider, Skeleton } from "@mui/material";

export default function ArticleDetailSkeleton() {
  return (
    <Box sx={{ px: 2 }}>
      <Skeleton animation="wave" variant="text" width={220} height={20} sx={{ mb: 2 }} />
      <Skeleton animation="wave" variant="rounded" width={84} height={22} sx={{ mb: 1.5 }} />
      <Skeleton animation="wave" variant="text" width="85%" height={44} sx={{ mb: 1 }} />
      <Skeleton animation="wave" variant="text" width="100%" height={20} />
      <Skeleton animation="wave" variant="text" width="92%" height={20} sx={{ mb: 2 }} />
      <Skeleton animation="wave" variant="text" width={280} height={18} sx={{ mb: 3 }} />
      <Divider sx={{ mb: 3 }} />
      {[0, 1, 2].map((i) => (
        <Box key={i} sx={{ mb: 4 }}>
          <Skeleton
            animation="wave"
            variant="text"
            width={170}
            height={22}
            sx={{ mb: 1.5 }}
          />
          <Skeleton animation="wave" variant="text" width="100%" />
          <Skeleton animation="wave" variant="text" width="100%" />
          <Skeleton animation="wave" variant="text" width="94%" />
          <Skeleton animation="wave" variant="text" width="98%" />
          <Skeleton animation="wave" variant="text" width="86%" />
        </Box>
      ))}
    </Box>
  );
}
